<template>
    <div class="email-right-aside bookmark-tabcontent form theme-form datepicker-responsive">
        <b-overlay :show="false" rounded="sm">
            <div class="card email-body radius-left">
                <div class="">
                    <div class="tab-content">
                        <div class="tab-pane fade" v-bind:class="'active show'">
                            <div class="card">
                                <div class="card-header d-flex customStickyCardHeader">
                                    <h6 class="mb-0" style="align-self: center;">{{ TypeName }}</h6>
                                </div>
                                <div class="card-body">
                                    <h6 v-if="FormType == 'getQuotation'">{{ Product }} - {{
                                        $t("lbl_EMPBE_RequestQuotation") }}</h6>
                                    <div class="form-group insideSection">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <textbox :title="$t('lbl_EMPBE_PurchaseQuantity')" readonly v-model="Qty"
                                                    type="number"></textbox>
                                            </div>
                                            <div class="col-sm-6">
                                                <textbox :title="$t('lbl_EMPBE_UOM')" disabled v-model="UOM"
                                                    >
                                                </textbox>
                                            </div>
                                            <div class="col-12">
                                                <customtextarea :title="$t('lbl_EMPBE_Content')" readonly v-model="Content">
                                                </customtextarea>
                                            </div>
                                        </div>
                                    </div>

                                    <h6>{{ $t('lbl_EMPBE_ContactInfo') }}</h6>
                                    <div class="form-group insideSection">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <textbox :title="$t('lbl_EMPBE_Salutation')" disabled v-model="Salutation"
                                                    >
                                                </textbox>
                                            </div>
                                            <div class="col-sm-6">
                                                <textbox :title="$t('lbl_EMPBE_Name')" readonly v-model="Name" type="text">
                                                </textbox>
                                            </div>
                                            <div class="col-12">
                                                <textbox :title="$t('lbl_EMPBE_CompanyName')" readonly v-model="CompanyName"
                                                    type="text"></textbox>
                                            </div>
                                            <div class="col-12">
                                                <textbox :title="$t('lbl_EMPBE_EmailAddress')" readonly
                                                    v-model="EmailAddress" type="email"></textbox>
                                            </div>
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-md-3 col-sm-6">
                                                        <textbox :title="$t('lbl_EMPBE_CountryCode')" type="number"
                                                            v-model="CountryCode" disabled></textbox>
                                                    </div>
                                                    <div class="col-md-3 col-sm-6">
                                                        <textbox :title="$t('lbl_EMPBE_AreaCode')" v-model="AreaCode"
                                                            type="number" :placeholder="$t('lbl_EMPBE_AreaCodePlaceholder')"
                                                            readonly>
                                                        </textbox>
                                                    </div>
                                                    <div class="col-md-3 col-sm-6">
                                                        <div class="form-group" id="CompanyContactNo">
                                                            <textbox :title="$t('lbl_EMPBE_TelNumber')" v-model="TelNo"
                                                                type="number" readonly></textbox>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-sm-6">
                                                        <div class="form-group" id="CompanyContatExtension">
                                                            <textbox :title="$t('lbl_EMPBE_TelExtension')"
                                                                v-model="TelExtension" type="number" readonly></textbox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>
<script>

import { InquiryFormService } from '../../_services'
export default {
    props: ["QuotationId", "fromAdmin"],
    components: {

    },
    data() {
        return {
            Product: "",
            Qty: "",
            UOM: "",
            Content: "",
            Salutation: "",
            Name: "",
            CompanyName: "",
            EmailAddress: "",
            CountryCode: "",
            AreaCode: "",
            TelNo: null,
            TelExtension: null,
            FormType: '',
            options_SupplyUnit: [
                {
                    id: '件',
                    label: '件'
                },
                {
                    id: '盒',
                    label: '盒'
                },
                {
                    id: '呎',
                    label: '呎'
                },
                {
                    id: '米',
                    label: '米'
                }
            ],
            options_Salutation: [
                {
                    id: 'Mr',
                    label: 'Mr'
                }
                , {
                    id: 'Mrs',
                    label: 'Mrs'
                }
                , {
                    id: '-',
                    label: '-'
                }
            ]
        }
    },

    methods: {
        initData() {
            var id = this.$route.params.id ? this.$route.params.id : this.QuotationId;
            if (id != "") {
                this.loadQuotation(id)
            }
        },
        loadQuotation(QuotationId) {
            var that = this;
            InquiryFormService.GetInquiryByAccount(QuotationId).then(res => {
                var data = res[0];
                that.bindData(data);
            })
        },
        bindData(data) {
            this.Product = this.langid == '1252' ? this.ExhibitNameE : this.langid == '950' ? this.ExhibitNameT : this.ExhibitNameS;
            this.Qty = data.qty == '0' ? '' : data.qty;
            this.UOM = data.uomText;
            this.Content = data.content;
            this.Salutation = data.initial;
            this.Name = data.surname;
            this.CompanyName = data.buyerCompName;
            this.EmailAddress = data.email
            this.CountryCode = data.tel_Country;
            this.AreaCode = data.tel_Area;
            this.TelNo = data.tel;
            this.TelExtension = data.tel_Ext;
            this.FormType = data.formType;
        }
    },
    created() {
        this.initData();
        this.$watch(
            () => this.$route.params,
            (toParams, previousParams) => {
                this.initData();
                // react to route changes...

            }
        )
    },
    computed: {
        TypeName() {
            if (this.FormType == 'getQuotation') {
                return this.$t("lbl_EMPBE_GetQuotation")
            } else {
                return this.$t("lbl_EMPBE_SourcingEnquiry")
            }
        },
        langid() {
            return localStorage.getItem("currentLangId")
        }


    }
}
</script>
